import * as React from "react";
import { Theme, WithStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { mockTheme } from "src/utils/utils";

const styles = (theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 10,
    alignItems: "center",
  },
  buttons: {
    margin: 10,
  },
  containerButtons: {
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
    position: "relative",
  },
});
const classesType = styles(mockTheme);

export interface UploadImageProps extends WithStyles<keyof typeof classesType> {
  label?: string;
  value?: any;
  doUpload?(event: any): void;
  onImageChange?(event: any): void;
  onCancel?(event: any): void;
}

const UploadImageWithoutStyles = (props: UploadImageProps) => {
  return (
    <div className={props.classes.root}>
      <div>
        <h3>{props.label}</h3>
      </div>
      <div>
        {props.value ? (
          <img src={props.value} style={{ maxWidth: 250 }} />
        ) : (
          <p>Sin imagen</p>
        )}
      </div>
      <div style={{ padding: 50 }}>
        <input
          type="file"
          name="file"
          accept="image/*"
          onChange={(event) => {
            console.log("ON CHANGE: ", event.target.files!.item(0));
            props.onImageChange!(event);
          }}
        />
      </div>
      <div className={props.classes.containerButtons}>
        <Button
          size="medium"
          className={props.classes.buttons}
          onClick={props.doUpload}
          variant="contained"
          color="primary"
        >
          Subir imagen
        </Button>

        <Button
          size="medium"
          className={props.classes.buttons}
          onClick={props.onCancel}
          variant="contained"
          color="secondary"
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
};

export const UploadImage = withStyles(styles as any)(UploadImageWithoutStyles);



// WEBPACK FOOTER //
// ./src/components/UploadImage.tsx